import Extent from '@arcgis/core/geometry/Extent';
import Geometry from '@arcgis/core/geometry/Geometry';
import Point from '@arcgis/core/geometry/Point';
import * as esriProjection from '@arcgis/core/geometry/projection';
import SpatialReference from '@arcgis/core/geometry/SpatialReference';

export function computeExtent(geometries: Geometry[], outputSpatialReference: SpatialReference) {
  let xmin: number | undefined;
  let xmax: number | undefined;
  let ymin: number | undefined;
  let ymax: number | undefined;

  for (const inputGeometry of geometries) {
    const geometry = esriProjection.project(inputGeometry, outputSpatialReference) as Geometry;

    if (geometry.type === 'point') {
      const point = geometry as Point;
      if (xmin === undefined) {
        xmin = point.x;
        xmax = point.x;
        ymin = point.y;
        ymax = point.y;
      } else {
        xmin = Math.min(xmin!, point.x);
        xmax = Math.max(xmax!, point.x);
        ymin = Math.min(ymin!, point.y);
        ymax = Math.max(ymax!, point.y);
      }
    } else {
      if (xmin === undefined) {
        xmin = geometry.extent.xmin;
        xmax = geometry.extent.xmax;
        ymin = geometry.extent.ymin;
        ymax = geometry.extent.ymax;
      } else {
        xmin = Math.min(xmin!, geometry.extent.xmin);
        xmax = Math.max(xmax!, geometry.extent.xmax);
        ymin = Math.min(ymin!, geometry.extent.ymin);
        ymax = Math.max(ymax!, geometry.extent.ymax);
      }
    }
  }
  return new Extent({ xmin: xmin, xmax: xmax, ymin: ymin, ymax: ymax, spatialReference: outputSpatialReference });
}
